import { render } from "./new-quote.vue?vue&type=template&id=15c213c2&scoped=true"
import script from "./new-quote.vue?vue&type=script&lang=js"
export * from "./new-quote.vue?vue&type=script&lang=js"

import "./new-quote.vue?vue&type=style&index=0&id=15c213c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c213c2"]])

export default __exports__